import { Breadcrumb, LogoMarquee } from '@/components'
import HeroBanner from './components/HeroBanner'
import ProductShowcase from './components/ProductShowcase'
import ServiceContent from './components/ServiceContent'
import ServiceFeatures from './components/ServiceFeatures'
import ShoppingCta from './components/ShoppingCta'

const HanedaShop = () => (
  <div className="min-w-[1200px]">
    <HeroBanner />
    <Breadcrumb currentKey="hanedaShop.breadcrumb.current" />
    <ProductShowcase />
    <div className="pt-[68px] pb-[48px] bg-[#FAFAFA]">
      <LogoMarquee />
    </div>
    <div className="bg-[#FAFAFA]">
      <ServiceContent />
    </div>
    <ServiceFeatures />
    <ShoppingCta />
  </div>
)

export default HanedaShop